module.exports = __webpack_public_path__ + "img/mousetrapper-logo.d47ae6b8.png";